// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		name: '九阵服务',
		obj:'宜宾九阵软件科技有限公司',
		type:'服务',
		describe:'服务赚钱服务赚钱服务赚钱',
		leader:'古永',
		state:'处理中',
		ways:'自动录入',
		date: '2015-05-21 | 00：00：00',
		province: '四川',
		city: '宜宾市',
		address: '宜宾市临港经济区化工路70号邦泰临港国际12栋1单元104号',
		zip: 666666,
	  },
		{
			name: '远程服务',
			obj:'水富市人民医院',
			type:'报表',
			describe:'信息科统计总人数不对',
			leader:'杨勇',
			state:'处理中',
			ways:'自动录入',
			date: '2024-05-20 | 18：26：28',
			province: '云南',
			city: '水富市',
			address: '云南省水富市高滩坝水富市人民医院',
			zip: 200333,
		  },
		{
            name: '报表处理',
			obj:'水富市人民医院',
			type:'报表',
			describe:'儿科、骨科统计八月到九月的住院总人数。',
			leader:'马科长',
			state:'处理中',
			ways:'手动录入',
            date: '2023-05-20 | 18：26：28',
            province: '云南',
            city: '水富市',
            address: '云南省水富市高滩坝水富市人民医院',
            zip: 200333,
          },
		{
            name: '系统装机',
			obj:'水富市人民医院',
			type:'硬件',
			describe:'信息科统计总人数不对',
			leader:'张培东',
			state:'已完成',
			ways:'手动录入',
			date: '2024-09-22 | 02：28：28',
            province: '四川',
            city: '宜宾市',
            address: '云南省水富市高滩坝水富市人民医院',
            zip: 200333,
          },
		  {
			name: '院区截图',
			obj:'水富市人民医院',
			type:'截图',
			describe:'给医院截图并查找修改对应的问题。',
			leader:'杨世江',
			state:'已完成',
			ways:'手动录入',
			date: '2024-09-22 | 01：26：28',
			province: '云南',
			city: '水富市',
			address: '云南省水富市高滩坝水富市人民医院',
			zip: 200333,
			},
			{
			  name: '院区截图',
			  obj:'水富市人民医院',
			  type:'截图',
			  describe:'给医院截图并查找修改对应的问题。',
			  leader:'陈南',
			  state:'已完成',
			  ways:'手动录入',
			  date: '2020-06-02 | 09：26：28',
			  province: '云南',
			  city: '水富市',
			  address: '云南省水富市高滩坝水富市人民医院',
			  zip: 200333,
			  },
			  {
				name: '院区截图',
				obj:'水富市人民医院',
				type:'截图',
				describe:'给医院截图并查找修改对应的问题。',
				leader:'吴笙榕',
				state:'已完成',
				ways:'手动录入',
				date: '2020-06-02 | 09：26：28',
				province: '上海',
				city: '普陀区',
				address: '云南省水富市高滩坝水富市人民医院',
				zip: 200333,
				},
			{
				name: '数据错误',
				obj:'宜宾市川南骨科医院',
				type:'数据',
				describe:'信息科统计总人数不对',
				leader:'杜作强',
				state:'已完成',
				ways:'手动录入',
				date: '2019-05-02 | 08：26：28',
				province: '四川',
				city: '宜宾市',
				address: '四川省宜宾市川南骨科医院',
				zip: 200333,
			  },
]

